module.exports = __webpack_public_path__ + "static/media/halo-fix-background.39bc621d.svg";